/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  var form = document.querySelector('.ProductForm');
  if (!form) return;
  function normalizeStockCopy() {
    var message = form.querySelector('.ewck-ss-t');
    if (!message) return;
    var match = message.textContent.match(/(?:Dépêchez-vous\s*)?(\d+)\s*(?:éléments?|articles?)\s+en stock!?/);
    if (!match) return;
    var quantity = Number(match[1]);
    Array.prototype.forEach.call(message.childNodes, function (node) {
      if (node.nodeType !== 3) return;
      if (node.textContent.indexOf('Dépêchez-vous') !== -1) node.textContent = '';
      if (/éléments?\s+en stock/.test(node.textContent)) {
        node.textContent = quantity === 1 ? ' article en stock' : ' articles en stock';
      } else if (/articles?\s+en stock/.test(node.textContent)) {
        var suffix = quantity === 1 ? ' article en stock' : ' articles en stock';
        if (node.textContent !== suffix) node.textContent = suffix;
      }
    });
  }
  normalizeStockCopy();
  new MutationObserver(normalizeStockCopy).observe(form, { childList: true, subtree: true, characterData: true });
})();

(function () {
  var form = document.querySelector('.ProductForm');
  if (!form) return;
  function expandGiftTargets() {
    form.querySelectorAll('.ewck-pao-c-b').forEach(function (input) {
      if (input.closest('label')) return;
      var label = document.createElement('label');
      label.className = 'VroliseGiftToggle';
      input.parentNode.insertBefore(label, input);
      label.appendChild(input);
    });
  }
  expandGiftTargets();
  new MutationObserver(expandGiftTargets).observe(form, { childList: true, subtree: true });
})();

/* Finding 1: this deferred file runs before Upsell Kit's deferred loader.
 * Omit only its attention-animation tool, before it can create any interval. */
if (window.CKTools) delete window.CKTools.animate_add_to_cart;

/* Finding 2: preserve the theme's logical drawer/focus/cart controller.
 * Intercept pointer close intent; commit its native close only when offscreen. */
(function () {
  var reduced = window.VroliseMotion.reduced;
  var controllers = new Map();
  var keyboard = false;
  document.addEventListener('keydown', function () { keyboard = true; }, true);
  document.addEventListener('pointerdown', function () { keyboard = false; }, true);

  function attach(drawer) {
    if (controllers.has(drawer)) return;
    var header = drawer.querySelector('.Drawer__Header');
    var close = drawer.querySelector('.Drawer__Close');
    if (!header || !close) return;
    var direction = drawer.classList.contains('Drawer--fromLeft') ? -1 : 1;
    var width = drawer.getBoundingClientRect().width;
    var x = direction * width, velocity = 0, target = x;
    var damping = 41.89, frame = 0, previous = 0, fade = 0;
    var drag = null, bypass = false, closing = false, suppressClick = false;
    drawer.setAttribute('data-vr-spring', '');

    function paint() {
      drawer.style.transform = 'translate3d(' + x + 'px,0,0)';
    }
    function stop() {
      cancelAnimationFrame(frame);
      frame = 0;
      previous = 0;
    }
    function commitClose() {
      closing = false;
      suppressClick = false;
      bypass = true;
      drawer.querySelector('.Drawer__Close').click();
      bypass = false;
    }
    function finish() {
      x = target;
      velocity = 0;
      paint();
      drawer.style.willChange = '';
      if (closing) commitClose();
    }
    function tick(now) {
      frame = 0;
      var dt = previous ? (now - previous) / 1000 : 1 / 60;
      previous = now;
      if (drag) {
        paint();
        return;
      }
      if (reduced.matches) {
        fade += dt;
        var alpha = 1 - Math.exp(-dt / .025);
        var opacity = Number(drawer.style.opacity || 1);
        drawer.style.opacity = opacity + ((closing ? 0 : 1) - opacity) * alpha;
        if (fade >= .12) {
          drawer.style.opacity = '';
          finish();
          return;
        }
      } else {
        // Exact damped-spring step: position and px/s velocity survive retargets.
        var omega = Math.sqrt(438.65), offset = x - target;
        var a = damping / 2, decay = Math.exp(-a * dt);
        if (damping === 41.89) {
          var b = velocity + omega * offset;
          decay = Math.exp(-omega * dt);
          x = target + (offset + b * dt) * decay;
          velocity = (velocity - omega * b * dt) * decay;
        } else {
          var frequency = Math.sqrt(438.65 - a * a);
          var sin = Math.sin(frequency * dt), cos = Math.cos(frequency * dt);
          var coefficient = (velocity + a * offset) / frequency;
          x = target + decay * (offset * cos + coefficient * sin);
          velocity = decay * (velocity * cos - (a * velocity + 438.65 * offset) / frequency * sin);
        }
        paint();
        if (Math.abs(x - target) < .1 && Math.abs(velocity) < 1) {
          finish();
          return;
        }
      }
      frame = requestAnimationFrame(tick);
    }
    function settle(open, releaseVelocity, instant) {
      if (drag) {
        var pointerId = drag.id;
        drag = null;
        if (drawer.hasPointerCapture(pointerId)) drawer.releasePointerCapture(pointerId);
      }
      closing = !open;
      target = open ? 0 : direction * width;
      damping = releaseVelocity === undefined ? 41.89 : 33.51;
      if (releaseVelocity !== undefined) velocity = releaseVelocity;
      stop();
      fade = 0;
      if (instant) {
        drawer.style.opacity = '';
        finish();
        return;
      }
      if (reduced.matches) {
        x = 0;
        paint();
        if (open && drawer.style.opacity === '') drawer.style.opacity = '0';
      }
      drawer.style.willChange = reduced.matches ? 'opacity' : 'transform';
      frame = requestAnimationFrame(tick);
    }
    function sync() {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        settle(true, undefined, keyboard);
      } else {
        stop();
        closing = false;
        target = x = direction * width;
        velocity = 0;
        drawer.style.opacity = '';
        drawer.style.willChange = '';
        paint();
      }
    }
    var controller = {
      drawer: drawer,
      close: function () { if (!bypass) settle(false, undefined, keyboard); },
      open: function () { settle(true, undefined, keyboard); },
      bypass: function () { return bypass; }
    };
    controllers.set(drawer, controller);
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();

    function release(event, cancelled) {
      if (!drag || event.pointerId !== drag.id) return;
      var held = drag;
      drag = null;
      if (drawer.hasPointerCapture(held.id)) drawer.releasePointerCapture(held.id);
      if (!held.active) {
        settle(!closing, undefined, keyboard);
        return;
      }
      suppressClick = true;
      if (cancelled) {
        settle(true, 0, false);
        return;
      }
      held.samples.push({ x: x, time: event.timeStamp });
      var samples = held.samples.filter(function (sample) { return event.timeStamp - sample.time <= 80; });
      var first = samples[0], last = samples[samples.length - 1];
      var speed = last.time > first.time ? (last.x - first.x) * 1000 / (last.time - first.time) : 0;
      var projected = x + (speed / 1000) * .998 / (1 - .998);
      settle(direction * projected < width / 2, speed, false);
    }
    drawer.addEventListener('pointerdown', function (event) {
      if (!event.target.closest('.Drawer__Header') || reduced.matches || !event.isPrimary || event.button !== 0 || drag ||
          event.target.closest('button, a, input, select, textarea')) return;
      suppressClick = false;
      // Read presentation, never the logical target, when catching a moving sheet.
      x = new DOMMatrixReadOnly(getComputedStyle(drawer).transform).m41;
      stop();
      drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY,
        origin: x, active: false, samples: [{ x: x, time: event.timeStamp }] };
      drawer.setPointerCapture(event.pointerId);
    });
    drawer.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.startX, dy = event.clientY - drag.startY;
      if (!drag.active) {
        if (Math.hypot(dx, dy) < 10) return;
        if (Math.abs(dx) <= 1.2 * Math.abs(dy)) { release(event, true); return; }
        drag.active = true;
      }
      event.preventDefault();
      var next = drag.origin + dx;
      var distance = direction * next;
      var edge = Math.max(0, Math.min(width, distance));
      var overshoot = distance - edge;
      x = direction * (edge + overshoot * width * .55 / (width + .55 * Math.abs(overshoot)));
      drag.samples.push({ x: x, time: event.timeStamp });
      drag.samples = drag.samples.filter(function (sample) { return event.timeStamp - sample.time <= 80; });
      if (!frame) frame = requestAnimationFrame(tick);
    });
    drawer.addEventListener('pointerup', function (event) { release(event, false); });
    drawer.addEventListener('pointercancel', function (event) { release(event, true); });
    drawer.addEventListener('lostpointercapture', function (event) { release(event, true); });
    drawer.addEventListener('click', function (event) {
      if (!suppressClick || event.detail === 0) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    });
    new ResizeObserver(function () {
      var nextWidth = drawer.getBoundingClientRect().width;
      if (nextWidth === width) return;
      width = nextWidth;
      if (drawer.getAttribute('aria-hidden') === 'true') sync();
      else if (!drag) settle(!closing, undefined, keyboard);
    }).observe(drawer);
    reduced.addEventListener('change', function () {
      if (drag) release({ pointerId: drag.id, timeStamp: performance.now() }, true);
      settle(drawer.getAttribute('aria-hidden') === 'false' && !closing, undefined, true);
    });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-action="open-drawer"], [data-action="close-drawer"]');
    var controller = trigger && controllers.get(document.getElementById(trigger.getAttribute('data-drawer-id')));
    if (trigger && trigger.getAttribute('data-action') === 'open-drawer') {
      if (controller && controller.drawer.getAttribute('aria-hidden') === 'false') controller.open();
      return;
    }
    if (!controller && event.target.closest('.PageOverlay')) {
      controllers.forEach(function (candidate) {
        if (candidate.drawer.getAttribute('aria-hidden') === 'false') controller = candidate;
      });
    }
    if (!controller || controller.bypass() || controller.drawer.getAttribute('aria-hidden') !== 'false') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    controller.close();
  }, true);
  document.querySelectorAll('#sidebar-menu, #sidebar-cart').forEach(attach);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('#sidebar-menu, #sidebar-cart').forEach(attach);
  });
})();

(function () {
  var fades = new Map();
  function attach(root) {
    root.querySelectorAll('#sidebar-menu .Collapsible').forEach(function (item, index) {
      var button = item.querySelector('.Collapsible__Button');
      var content = item.querySelector('.Collapsible__Inner');
      if (!button || !content || content.hasAttribute('data-vr-disclosure')) return;
      content.setAttribute('data-vr-disclosure', '');
      content.id = content.id || 'vrolise-menu-disclosure-' + index;
      button.setAttribute('aria-controls', content.id);
      content.hidden = button.getAttribute('aria-expanded') !== 'true';
    });
  }
  function setOpen(item, open) {
    var button = item.querySelector('.Collapsible__Button');
    var content = item.querySelector('[data-vr-disclosure]');
    if (!button || !content) return;
    var opacity = Number(getComputedStyle(content).opacity);
    if (fades.has(content)) { fades.get(content).cancel(); fades.delete(content); }
    if (!open && content.contains(document.activeElement)) button.focus({ preventScroll: true });
    var wasHidden = content.hidden;
    content.hidden = !open;
    button.setAttribute('aria-expanded', String(open));
    if (open && !window.VroliseMotion.keyboard && !window.VroliseMotion.reduced.matches) {
      var fade = content.animate([{ opacity: wasHidden ? .55 : opacity }, { opacity: 1 }], { duration: 120, easing: 'ease-out' });
      fades.set(content, fade);
      fade.onfinish = function () { fades.delete(content); };
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('#sidebar-menu [data-action="toggle-collapsible"]');
    var item = button && button.closest('.Collapsible');
    if (!item || !item.querySelector('[data-vr-disclosure]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var open = button.getAttribute('aria-expanded') !== 'true';
    Array.from(item.parentElement.children).forEach(function (sibling) {
      if (sibling !== item && sibling.matches('.Collapsible')) setOpen(sibling, false);
    });
    setOpen(item, open);
  }, true);
  window.VroliseMotion.reduced.addEventListener('change', function () {
    if (window.VroliseMotion.reduced.matches) { fades.forEach(function (fade) { fade.cancel(); }); fades.clear(); }
  });
  attach(document);
  document.addEventListener('shopify:section:load', function () { attach(document); });
})();
